export default __webpack_public_path__ + "static/media/family name.d3f53e88.png";